import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import { TranslationKey } from '@shared/translations/auto-generated/translation-key';

/**
 * Extends 'translate' pipe from @ngx-translate to make sure the translation is typed/exists and avoid typos
 * Check script for generating translations in README
 */
@Pipe({
    name: 'translateSafe',
    pure: false,
    standalone: true
})
export class TranslateSafePipe extends NgxTranslatePipe implements PipeTransform {
    transform(value: TranslationKey, ...args: unknown[]): string {
        return super.transform(value, ...args);
    }
}
